import { render } from "./Folder.vue?vue&type=template&id=a747ee2c&scoped=true"
import script from "./Folder.vue?vue&type=script&lang=js"
export * from "./Folder.vue?vue&type=script&lang=js"

import "./Folder.vue?vue&type=style&index=0&id=a747ee2c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a747ee2c"]])

export default __exports__